<template>
  <div>
    <div
      v-show="!isEmpty"
      ref="lineChart"
      style="height: 500px;"
    />
    <Empty
      v-show="isEmpty"
      style="border:none"
      tips="图表暂无数据哦～"
    />
  </div>
</template>

<script>
import echarts from 'echarts';
import cloneDeep from 'lodash/cloneDeep';
import { Empty } from '@/components';

export default {
  name: 'LineChart',
  components: {
    Empty,
  },
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    dimension: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      chartOptions: {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          left: 'left',
          top: 24,
          data: [],
        },
        series: [],
      },
      chart: null,
    };
  },
  computed: {
    isEmpty() {
      return !this.chartData || this.chartData.data.list.length < 1;
    },
  },
  watch: {
    chartData: {
      immediate: true,
      handler(info) {
        if (!info) return;
        this.renderChart();
      },
    },
    dimension: {
      immediate: true,
      handler(info) {
        if (!this.chartData) return;
        this.renderChart();
      },
    },
  },
  methods: {
    renderChart() {
      if (this.isEmpty) return;
      // let targetName = this.dimension.label;
      let chartData = this.chartData.data;
      let options = cloneDeep(this.chartOptions);
      /*
      options.title = {
        text: targetName,
        textStyle: {
          fontSize: 16,
          color: 'black'
        },
        top: 68,
        left: '2%'
      };
      */
      let legends = chartData.labels;
      options.legend.data = legends;
      // TODO: 王媛大脑袋的要求，如果返回的类目太多，默认只勾选前10个展示
      let selected = {};
      legends.forEach((item, index) => {
        if (index < 10) {
          selected[item] = true;
        } else {
          selected[item] = false;
        }
      });
      options.legend.selected = selected;
      options.xAxis = {
        type: 'category',
        data: chartData.dates,
      };
      options.yAxis = {
        type: 'value',
      };
      options.series = chartData.list.map((item, index) => {
        return {
          type: 'line',
          smooth: true,
          name: legends[index],
          data: item[this.dimension.value],
        };
      });
      this.$nextTick(() => {
        if (!this.chart) {
          this.chart = echarts.init(this.$refs['lineChart']);
        }
        this.chart.setOption(options);
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
